import sms from './sms'
import email from './email'
import notification from './notification'

export default {
  name: 'MessageMessages',
  path: 'messages',
  meta: {
    label: 'messages',
    auth: 'message'
  },
  component: {
    name: 'Message',
    render(c) {
      return c('router-view')
    }
  },
  children: [sms, email, notification]
}
